import React from 'react';
import { observer } from 'mobx-react';

import Collaborators from 'libs/rendering/components/header/collaborators';
import { frameStore } from 'apps/components/Frame/appManager';

export const CollaboratorsContainer = observer(() => {
  // const { route } = routerStore;
  const { contextManager, sharedFileManager } = frameStore;
  const usersActivity = contextManager?.usersActivity;
  if (
    !usersActivity ||
    !sharedFileManager // || noMakeButtonRoutes.includes(route.name)
  ) {
    return null;
  }

  return (
    <Collaborators
      usersActivity={usersActivity}
      sharedFileManager={sharedFileManager}
    />
  );
});
